// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dnd-list {
  margin: 0;
  padding: 0;
  list-style-type: none !important;
}

.dnd-list li {
  counter-increment: dnd-step-counter;
  margin-bottom: 10px;
  padding: 0.5em;
}

.dnd-list li::before {
  content: counter(dnd-step-counter);
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 3px;
  background-color: var(--chakra-colors-gray-200);
  border: 1px solid var(--chakra-colors-gray-400);
  color: var(--chakra-colors-gray-600);
  margin-right: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/template/dnd.css"],"names":[],"mappings":";AACA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;AACrB","sourcesContent":["\n.dnd-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none !important;\n}\n\n.dnd-list li {\n  counter-increment: dnd-step-counter;\n  margin-bottom: 10px;\n  padding: 0.5em;\n}\n\n.dnd-list li::before {\n  content: counter(dnd-step-counter);\n  font-weight: bold;\n  padding: 3px 8px;\n  border-radius: 3px;\n  background-color: var(--chakra-colors-gray-200);\n  border: 1px solid var(--chakra-colors-gray-400);\n  color: var(--chakra-colors-gray-600);\n  margin-right: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
